import TextArea from "../../components/inputs/textArea";
import TextInput from "../../components/inputs/textInput";
import { useOptions } from "../../components/hooks/useOptionsHook";
import { useFormik } from "formik";
import * as yup from "yup";
import Select from "../../components/select/select";
import Button from "../../components/buttons/button";
const SendNotification = ({ t, setOpen }) => {
  const { memberStatusOptions } = useOptions();
  const validationSchema = yup.object({
    notificationTitle: yup.string().required(t("required")),
    notificationText: yup.string().required(t("required")),
    sendTo: yup.string().required(t("required")),
  });
  const formik = useFormik({
    initialValues: {
      notificationTitle: "",
      notificationText: "",
      sendTo: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
      setOpen(false);
    },
  });
  return (
    <section className="space-y-4">
      <div>
        <h4 className="font-medium">دورة كاراتيه</h4>
        <p className="font-medium text-mainGray">20/06/2025</p>
      </div>
      <TextInput
        formik={formik}
        placeholder={t("notificationTitle")}
        label={t("notificationTitle")}
        name={"notificationTitle"}
      />
      <TextArea
        formik={formik}
        placeholder={t("notificationText")}
        label={t("notificationText")}
        name={"notificationText"}
      />
      <Select
        options={memberStatusOptions}
        formik={formik}
        name={"sendTo"}
        label={t("sendTo")}
        placeholder={t("sendTo")}
      />

      <div className="flex items-center justify-end gap-3">
        <Button className={"bg-primary justify-center w-fit text-[#1F384C] text-sm"}>
          {t("sendNotification2")}
        </Button>
        <Button
          className={"border border-white text-white text-sm"}
          type="button"
          onClick={() => setOpen(false)}
        >
          {t("cancel")}
        </Button>
      </div>
    </section>
  );
};

export default SendNotification;
